import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import ProductCard from '../components/shared/ProductCard';

export default function Wishlist() {
  const { wishlist } = useCart();
  const products = wishlist.products || [];

  return (
    <div className="min-h-screen px-6 md:px-12 lg:px-20 py-10">
      <p className="label-sm text-lux-gold mb-2">Your Curation</p>
      <h1 className="font-display text-4xl text-lux-primary mb-2">Wishlist</h1>
      <p className="font-sans text-sm text-lux-secondary mb-10">{products.length} {products.length === 1 ? 'piece' : 'pieces'} saved</p>

      {products.length === 0 ? (
        <div className="text-center py-20">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#C6A75E" strokeWidth="1" className="mx-auto mb-6">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
          </svg>
          <p className="font-display text-3xl text-lux-primary mb-3">Your wishlist is empty</p>
          <p className="font-sans text-lux-secondary mb-8">Save pieces you love for later</p>
          <Link to="/shop" className="btn-primary">Explore Collection</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map(p => <ProductCard key={p._id} product={p} />)}
        </div>
      )}
    </div>
  );
}
